import { Button, Col, Collapse, Form, message, Modal, Popover, Row, Select, Space } from "antd";
import { MinusOutlined } from '@ant-design/icons'
import TextArea from "antd/lib/input/TextArea";
import { FC, ReactNode, useState } from "react";
import appConfig from "../../../../appConfig";
import Icon from "../../../../assets/icons/icon";
import AutoCalcSwitch from "../../../../components/form/autoCalcSwitch";
import InputNum from "../../../../components/form/inputNum";
import SwitchInput from "../../../../components/form/switchInput";
import InfoList from "../../../../components/infoList";
import DividerLine from "../../../../components/lineSplit";
import { renderErrorMessage } from "../../../../components/messages/errorMessage";
import openModal from "../../../../components/modal/openModal";
import TaxCaseStore from "../../../../contexts/taxCaseStore";
import TaxFlowStore, { TaxFlow } from "../../../../contexts/taxFlowStore";
import _t from "../../../../lang/translate";
import { saveActivity } from "../../../../services/activityService";
import { openFileLink } from "../../../../services/mediaService";
import { followUpOnCase, publishTaxOffer, sentTaxOffer, toggleAcceptable } from "../../../../services/taxService";
import { SendOfferFormType, TaxCase } from "../../../../types/taxTypes";
import { Strict } from "../../../../types/utilTypes";
import format from "../../../../utilities/formatNumbers";
import { safeNum } from "../../../../utilities/number";
import { isValidNum } from "../../../../utilities/typeGuard";
import { getDeprecitation } from "../calc/metaCalculators";
import RegistrationFee from "./taxFlowRegistrationFee";
import { emissionCategoryWarningCheck } from "../../../../components/vehicleInfoViews/editVehicleInstanceData";
import CopyableContent from "../../../../components/copyableContent";
import LogText from "../../../../components/logText";
import { EquipmentCatalog } from "../../../../types/newPriceTypes";
import moment from 'moment'

export default function TaxFlowOffer() {


  return (
    <div className="p-1">
      <Row gutter={[16, 16]}>
        <Col order={1} span={24} xl={{ span: 12, order: 0 }} xxl={14}>
          <RegistrationFee />
        </Col>
        <Col order={0} span={24} xl={{ span: 12, order: 1 }} xxl={10}>
          <Offer />
        </Col>
      </Row>
    </div>
  )
}

function Offer() {
  const { taxFlow, setTaxFlow, setLocks, taxScenario, dirty, caseLocked, mountedDATEquipment } = TaxFlowStore.useContainer()
  const { taxCase, setTaxCase } = TaxCaseStore.useContainer()
  const [loading, setLoading] = useState(false)
  const [visibleOfferModal, setVisibleOfferModal] = useState(false)
  const offer = taxFlow.offer;
  const isWidgetCase = taxCase.caseSourceId === appConfig("widgetCaseSourceId");
  const shouldDisplayB2CCollateral = isWidgetCase && !taxCase.taxCaseValueConfig?.disableWidgetB2cCollateral.value
  const offerButtonText = taxCase.flags.sent ? _t("send_new") : _t("send");
  const offerTitle = taxCase.flags.sent ? _t("send_new", "preassessment") : _t("send", "preassessment");
  const taxableValueIsOK = validateTaxableValue(taxCase, taxFlow)
  const warnings = getCaseWarnings(taxCase);

  function handleRegFeeChange(val: unknown) {
    setTaxFlow((prev) => ({
      ...prev,
      registrationFee: {
        ...prev.registrationFee,
        registrationFee: safeNum(val) ?? null,
      },
    }))
  }
  function handleCollateralFeeChange(val: unknown, key: keyof Strict<Strict<TaxFlow>['offer']>['collateral']) {
    setTaxFlow((prev) => ({
      ...prev,
      offer: {
        ...prev.offer,
        collateral: {
          ...prev.offer?.collateral,
          [key]: safeNum(val) ?? undefined,
        }
      }
    }))
  }
  function handleLicensePlateFeeChange(val: unknown) {
    setTaxFlow((prev) => ({
      ...prev,
      offer: {
        ...prev.offer,
        licensePlateFee: safeNum(val) ?? undefined,
      }
    }))
  }
  function handleCaseFeeChange(val: unknown) {
    setTaxFlow((prev) => ({
      ...prev,
      offer: {
        ...prev.offer,
        caseFee: safeNum(val) ?? undefined,
      }
    }))
  }
  function handleSpecialDiscountChange(val: unknown) {
    setTaxFlow((prev) => ({
      ...prev,
      offer: {
        ...prev.offer,
        specialCaseFeeDiscount: safeNum(val) ?? undefined,
      }
    }))
  }

  const getAcceptableState = (values: SendOfferFormType) => {
    const taxableValueIsOK = validateTaxableValue(taxCase, taxFlow)
    return taxableValueIsOK && !values.message;
  }

  const emissionAmount = taxCase.vehicle?.emissionAmount;
  const dmrEmission = taxCase.vehicle?.remoteData?.dmr?.mapped?.emissionAmount;
  const datEmission = taxCase.vehicle?.remoteData?.dat?.mapped?.emissionAmount;
  const { cat, datCat, dmrCat, emissionCategoryShouldWarn, sameDat, sameDmrDat, sameDmr } = emissionCategoryWarningCheck({
    emissionAmount, datEmission, dmrEmission
  })
  async function handleOfferSubmit(values: SendOfferFormType) {
    if (emissionCategoryShouldWarn) {
      Modal.confirm({
        title: "CO₂-data stemmer ikke overens",
        width: 600,
        content: (
          <div>
            <p>
              Der er uoverensstemmelse mellem indtastet CO₂ og data fra DAT/DMR.
            </p>
            <p>
              Hvis du fortsætter, kan forhåndsvurderingen blive beregnet forkert.
            </p>
            <p>
              Vi anbefaler, at du kontrollerer værdien før afsendelse.
            </p>
            <Row wrap={false} className={`${!(sameDat || sameDmr) ? "text-danger" : ""}`}>
              <Col flex="120px">CO2-emission:</Col>
              <Col flex="56px">{format.emission(emissionAmount)}</Col>
              <Col>{cat}</Col>
            </Row>
            <Row wrap={false} className={`${!sameDmrDat ? "text-danger" : ""}`} >
              <Col flex="120px">For DMR:</Col>
              <Col flex="56px">{format.emission(dmrEmission)}</Col>
              <Col>{dmrCat}</Col>
            </Row>
            <Row wrap={false} className={`${!sameDmrDat ? "text-danger" : ""}`}>
              <Col flex="120px">For DAT:</Col>
              <Col flex="56px">{format.emission(datEmission)}</Col>
              <Col>{datCat}</Col>
            </Row>

          </div>
        ),
        okText: "Send alligevel",
        autoFocusButton: "cancel",
        cancelText: _t("cancel"),
        okButtonProps: { danger: true },
        onOk: async () => {
          await sendOffer(values);
        }

      });
    } else {
      await sendOffer(values)
    }
  }
  const sendOffer = async (values: SendOfferFormType) => {
    setLoading(true);
    try {
      values.isAcceptable = getAcceptableState(values)
      if (!isValidNum(taxCase.vehicle?.emissionAmount)) {
        setVisibleOfferModal(false)
        throw new Error(_t("msg.co2_emission_must_be_filled"))
      }
      const { data } = await sentTaxOffer(taxCase.id, values);
      setTaxCase(data);
      message.success(_t("offer", "sent"));
      setVisibleOfferModal(false);
    } catch (error) {
      renderErrorMessage(error)
    } finally {
      setLoading(false);
    }
  };
  async function isAcceptable() {
    setLoading(true);
    try {
      const newStatus = !taxScenario?.flags?.acceptable
      const { data } = await toggleAcceptable(taxCase.id, { status: newStatus });
      setTaxCase(data);
      if (newStatus) {
        message.success(_t("msg.offer_acceptable"));
      } else {
        message.warning(_t("msg.offer_not_acceptable"));
      }
    } catch (error) {
      renderErrorMessage(error)
    } finally {
      setLoading(false);
    }
  }
  const publishOffer = async () => {
    setLoading(true);
    try {
      const newStatus = !taxScenario?.flags?.published
      const { data } = await publishTaxOffer(taxCase.id, { status: newStatus });
      setTaxCase(data);
      message.success(_t(newStatus ? "offer_published" : "offer_unpublished"));
    } catch (error) {
      renderErrorMessage(error)
    } finally {
      setLoading(false);
    }
  };

  const followUp = async () => {
    setLoading(true);
    try {
      if (!taxCase.flags.followUp) {
        const { note } = await openModal("note", null) as { note: string }
        await saveActivity("tax", taxCase.id, {
          id: '',
          isImportant: true,
          isPublic: false,
          note: note,
          send: false,
        });
      }
      const { data } = await followUpOnCase(taxCase.id, { status: !taxCase.flags.followUp });
      setTaxCase(data);
      message.success(_t("saved"));
    } catch (error) {
      renderErrorMessage(error)
    } finally {
      setLoading(false);
    }
  };

  const getDefaultMessage = () => {
    const daysUntilFirstBirthday = 365 - moment().diff(taxCase.vehicle?.firstRegDate, "days");

    if (!isValidNum(dmrEmission)) return reservationOptions[1].value;
    if (!taxableValueIsOK) return reservationOptions[3].value;
    if (!taxCase.vehicle?.vin) return reservationOptions[0].value
    if (daysUntilFirstBirthday >= 0 && daysUntilFirstBirthday <= 30) return reservationOptions[5].value

    return null
  }

  return (
    <div className="border-light border-radius bg-light p-1">
      <h3 className="mb-1">Tilbud (Forhåndsvurdering)</h3>
      <Form labelCol={{ xs: 24, lg: 10, xl: 8, className: "text-left" }}
        wrapperCol={{ xs: 24, lg: 14, xl: 16 }}
        colon={false}
      >
        <Row className="flex-nowrap">
          <Col flex="auto">
            <Form.Item label={_t("registration_fee")}
              extra={
                safeNum(taxFlow.projected?.estimatedRegistrationFee) !== undefined && (
                  <small className="muted mt-02">
                    Est. afg. 2027: {format.price(taxFlow.projected?.estimatedRegistrationFee)}
                  </small>
                )
              }
            >
              <InputNum
                min={0} className="bg-white no-border" suffix="Kr."
                disabled={taxFlow.autoCalc?.registrationFee}
                value={taxFlow?.registrationFee?.registrationFee ?? undefined}
                onChange={handleRegFeeChange}
              />
            </Form.Item>
          </Col>
          <Col flex="31px">
            <AutoCalcSwitch value={taxFlow.autoCalc?.registrationFee} onChange={v => setLocks({ registrationFee: v })} />
          </Col>
        </Row>

        {shouldDisplayB2CCollateral ? (
          <>
            <Form.Item label={_t("estimated", "collateral")}>
              <InputNum min={0} className="bg-white no-border" suffix="Inkl. moms" disabled
                value={offer?.collateral?.total ?? undefined}
              />
            </Form.Item>
            <div style={{ paddingLeft: 24 }}>
              <Row className="flex-nowrap">
                <Col flex="auto">
                  <Form.Item label={_t("collateral") + " (standard)"}>
                    <InputNum min={0} className="bg-white no-border" suffix="Kr."
                      disabled={taxFlow.autoCalc?.collateralFee}
                      value={offer?.collateral?.baseFee ?? undefined}
                      onChange={(v) => handleCollateralFeeChange(v, 'baseFee')}
                    />
                  </Form.Item>
                </Col>
                <Col flex="31px">
                  <AutoCalcSwitch value={taxFlow.autoCalc?.collateralFee} onChange={v => setLocks({ collateralFee: v })} />
                </Col>
              </Row>
              <Row className="flex-nowrap">
                <Col flex="auto">
                  <Form.Item label={<>
                    {_t("collateral") + " (b2c)"}
                    <DisplayRiskFeeCalcuation />
                  </>}>
                    <InputNum min={0} className="bg-white no-border" suffix="Kr."
                      disabled={taxFlow.autoCalc?.collateralFeeB2C}
                      value={offer?.collateral?.b2cFee ?? undefined}
                      onChange={(v) => handleCollateralFeeChange(v, 'b2cFee')}
                    />
                  </Form.Item>
                </Col>
                <Col flex="31px">
                  <AutoCalcSwitch value={taxFlow.autoCalc?.collateralFeeB2C} onChange={v => setLocks({ collateralFeeB2C: v })} />
                </Col>
              </Row>
            </div>
          </>
        ) : (
          <Row className="flex-nowrap">
            <Col flex="auto">
              <Form.Item label={_t("collateral")}>
                <InputNum min={0} className="bg-white no-border" suffix="Inkl. moms"
                  disabled={taxFlow.autoCalc?.collateralFee}
                  value={offer?.collateral?.total ?? undefined}
                  onChange={(v) => handleCollateralFeeChange(v, 'total')}
                />
              </Form.Item>
            </Col>
            <Col flex="31px">
              <AutoCalcSwitch value={taxFlow.autoCalc?.collateralFee} onChange={v => setLocks({ collateralFee: v })} />
            </Col>
          </Row>
        )}

        <Row className="flex-nowrap">
          <Col flex="auto">
            <Form.Item label={_t("plade_nr_fee")}>
              <InputNum min={0} className="bg-white no-border" suffix="Kr."
                value={offer?.licensePlateFee ?? undefined}
                onChange={handleLicensePlateFeeChange}

              />
            </Form.Item>
          </Col>
          <Col flex="31px" />
        </Row>

        <Row className="flex-nowrap">
          <Col flex="auto">
            <Form.Item label={_t("fee")}>
              <InputNum suffix={"Inkl. moms"} min={0} className="bg-white no-border"
                disabled={taxFlow.autoCalc?.caseFee}
                value={offer?.caseFee ?? undefined}
                onChange={handleCaseFeeChange}
              />
            </Form.Item>
          </Col>
          <Col flex="31px">
            <AutoCalcSwitch value={taxFlow.autoCalc?.caseFee} onChange={v => setLocks({ caseFee: v })} />
          </Col>
        </Row>

        {/* <Row className="flex-nowrap"> */}
        {/*   <Col flex="auto"> */}
        {/*     <Form.Item label={_t("offer_discount")}> */}
        {/*       <InputNum suffix={"Kr."} min={0} className="bg-white no-border" */}
        {/*         prefix={<MinusOutlined />} */}
        {/*         disabled={taxFlow.autoCalc?.specialCaseFeeDiscount} */}
        {/*         value={offer?.specialCaseFeeDiscount ?? undefined} */}
        {/*         onChange={handleSpecialDiscountChange} */}
        {/*       /> */}
        {/*     </Form.Item> */}
        {/*   </Col> */}
        {/*   <Col flex="31px"> */}
        {/*     <AutoCalcSwitch value={taxFlow.autoCalc?.specialCaseFeeDiscount} onChange={v => setLocks({ specialCaseFeeDiscount: v })} /> */}
        {/*   </Col> */}
        {/* </Row> */}
        <DividerLine />
        <Form.Item label={_t("total_price")}>
          <CopyableContent contentToCopy={offer?.totalPrice?.toFixed(0) ?? ""}>
            <span>{format.price(offer?.totalPrice)}</span>
          </CopyableContent>
        </Form.Item>
      </Form>
      <Row justify="space-between">
        <Col>
          <Button
            disabled={!taxCase.links?.offerPdfLink}
            type="primary"
            ghost
            onClick={() => openFileLink(taxCase.links?.offerPdfLink)}
          >
            <Icon name="download-outline" size="large" />
            {_t("download")}
          </Button>
        </Col>
        <Col>
          <SendOfferValidationPopover taxCase={taxCase} taxFlow={taxFlow} dirty={dirty} mountedDATEquipment={mountedDATEquipment}>
            <Button disabled={!validateTaxCase(taxCase, taxFlow, dirty) || caseLocked} type="primary" onClick={() => setVisibleOfferModal(true)}>
              {offerButtonText}
            </Button>
          </SendOfferValidationPopover>

        </Col>
      </Row>
      {taxScenario?.logs?.sent && (
        <LogText
          className="p-0 mt-03 text-right"
          small
          logData={taxScenario?.logs?.sent}
          timeToSendOfferInMs={taxCase.timeToSendOfferInMs}
        />
      )}

      <Collapse defaultActiveKey={["settings"]} expandIconPosition="end" ghost className="mt-2 border-light">
        <Collapse.Panel key={"settings"} header={_t("settings")}>
          <Space className="w-100" direction="vertical">
            <SwitchInput
              size="small"
              loading={loading}
              checked={taxScenario?.flags?.acceptable}
              onChange={isAcceptable}
              label={_t("canBeAcceptedByCustomer")}
              disabled={caseLocked}
              id="isAcceptable-switch"
            />
            <SwitchInput
              size="small"
              loading={loading}
              checked={taxScenario?.flags?.published}
              onChange={publishOffer}
              label={_t("publish")}
              disabled={caseLocked}
              id="publish-switch"
            />
            <SwitchInput
              size="small"
              loading={loading}
              checked={taxCase.flags.followUp}
              onChange={followUp}
              label={_t("followup")}
              disabled={caseLocked}
              id="followup-switch"
            />
          </Space>
        </Collapse.Panel>
      </Collapse>

      <Modal
        title={null}
        visible={visibleOfferModal}
        destroyOnClose={true}
        footer={null}
        confirmLoading={loading}
        cancelButtonProps={{ disabled: loading }}
        onCancel={() => setVisibleOfferModal(false)}
      >
        <Form<SendOfferFormType>
          onFinish={handleOfferSubmit}
          initialValues={{ message: getDefaultMessage(), reservation: null }}
          layout="vertical"
        >

          <h2 className="modal-title">{offerTitle}</h2>
          <Form.Item
            name="message" label={_t("send_tax_offer_message_label")} rules={[{ required: false, whitespace: true }]}
          >
            <TextArea
              disabled={loading}
              autoSize={{ minRows: 1, maxRows: 3 }}
              placeholder={_t('send_tax_offer_placeholder')}
            />
          </Form.Item>

          <Form.Item shouldUpdate noStyle>
            {({ setFieldsValue }) => (
              <Form.Item name="reservation" label={_t('send_tax_offer_extra_details_label')}>
                <Select
                  showSearch
                  placeholder={_t('choose')}
                  options={reservationOptions}
                  onChange={(val) => {
                    setFieldsValue({
                      message: val,
                      reservation: null,
                    });
                  }}
                />
              </Form.Item>
            )}
          </Form.Item>

          <Row justify="space-between" align="bottom">
            <Col>
              {warnings.map((item, i) => <Warning {...item} key={i} />)}
            </Col>
            <Col >
              <Form.Item shouldUpdate noStyle>
                {({ submit }) => (
                  <div className="text-right">
                    <Space>
                      <Button type="ghost" onClick={() => setVisibleOfferModal(false)} disabled={loading}>
                        {_t("cancel")}
                      </Button>
                      <Button onClick={submit} loading={loading} type="primary">
                        {offerButtonText}
                      </Button>
                    </Space>
                  </div>
                )}
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </div>
  )
}



function DisplayRiskFeeCalcuation() {
  const { taxFlow } = TaxFlowStore.useContainer()
  const breakdown = taxFlow.offer?.collateral?.b2cBreakdown;
  return (<>
    <Popover title={"Sagstillæg udregning (B2C)"} overlayStyle={{ maxWidth: 300 }} content={
      <InfoList layout="horizontal" className="infolist-text-left">
        <InfoList.Item label="B2C standard" value={format.price(breakdown?.standard)} />
        <InfoList.Item label="B2C ikke-elbil" value={format.price(breakdown?.nonElectric)} />
        <InfoList.Item label="B2C elbil" value={format.price(breakdown?.electric)} />
        <InfoList.Item label="B2C Total" value={format.price(breakdown?.total)} bold />
      </InfoList>

    }>
      <Button
        size="small"
        type="text"
        shape="circle"
        tabIndex={-1}
        className="muted no-bg"
      >
        <Icon name="information-circle" />
      </Button>
    </Popover>

  </>)
}

const validateTaxCase = (taxCase: TaxCase, taxFlow: TaxFlow, dirty: boolean) => {
  if (dirty) return false;
  if (taxCase.vehicle?.isNew) {
    return isValidNum(taxCase.vehicle?.emissionAmount)
      && !!taxFlow.newPrice?.taxableValue
      && isValidNum(taxFlow.registrationFee?.registrationFee);
  }
  return isValidNum(taxCase.vehicle?.emissionAmount)
    && !!taxFlow?.tradePrice?.tradePrice
    && !!taxFlow?.newPrice?.newPrice
    && isValidNum(taxFlow.registrationFee?.registrationFee);
}

function SendOfferValidationPopover({ children, taxCase, taxFlow, dirty, mountedDATEquipment }: {
  children: ReactNode,
  taxCase: TaxCase,
  taxFlow: TaxFlow,
  dirty: boolean,
  mountedDATEquipment: EquipmentCatalog[]
}) {
  const emissionAmount = taxCase.vehicle?.emissionAmount;
  const dmrEmission = taxCase.vehicle?.remoteData?.dmr?.mapped?.emissionAmount;
  const datEmission = taxCase.vehicle?.remoteData?.dat?.mapped?.emissionAmount;

  const { cat, datCat, dmrCat, emissionCategoryShouldWarn, sameDat, sameDmrDat, sameDmr } = emissionCategoryWarningCheck({ emissionAmount, datEmission, dmrEmission })
  const valid = validateTaxCase(taxCase, taxFlow, dirty);
  return valid && !emissionCategoryShouldWarn && !mountedDATEquipment?.length ? <>{children}</> : (
    <Popover title={"Feltværdier påkrævet!"}
      content={
        <div>
          {dirty && (
            <p className={"text-danger"}>
              {_t("save_before_action")}
            </p>
          )}
          {mountedDATEquipment.length && (
            <p className="text-danger">Der er monteret DAT udstyr ({mountedDATEquipment.length})</p>
          )}

          {emissionCategoryShouldWarn && (
            <>
              <Row wrap={false} className={`${!(sameDat || sameDmr) ? "text-danger" : ""}`}>
                <Col flex="120px">CO2-emission:</Col>
                <Col flex="56px">{format.emission(emissionAmount)}</Col>
                <Col>{cat}</Col>
              </Row>
              <Row wrap={false} className={`${!sameDmrDat ? "text-danger" : ""}`} >
                <Col flex="120px">For DMR:</Col>
                <Col flex="56px">{format.emission(dmrEmission)}</Col>
                <Col>{dmrCat}</Col>
              </Row>
              <Row wrap={false} className={`${!sameDmrDat ? "text-danger" : ""} mb-1`}>
                <Col flex="120px">For DAT:</Col>
                <Col flex="56px">{format.emission(datEmission)}</Col>
                <Col>{datCat}</Col>
              </Row>
            </>
          )}
          {taxCase.vehicle?.isNew ? (
            <>
              <Row justify="space-between" gutter={16} className={!taxFlow.newPrice?.taxableValue ? "text-danger" : ""}>
                <Col>{_t("taxable_value")}</Col>
                <Col>{format.price(taxFlow.newPrice?.taxableValue)}</Col>
              </Row>
              <Row justify="space-between" gutter={16} className={!taxFlow.registrationFee?.registrationFee ? "text-danger" : ""}>
                <Col>{_t("registration_fee")}</Col>
                <Col>{format.price(taxFlow.registrationFee?.registrationFee)}</Col>
              </Row>
            </>
          ) : (
            <>
              {isValidNum(taxFlow?.newPrice?.newPrice) || isValidNum(taxFlow?.newPrice?.newPrice) || isValidNum(taxFlow?.newPrice?.newPrice) && (
                <>
                  <Row justify="space-between" gutter={16} className={!taxFlow?.newPrice?.newPrice ? "text-danger" : ""}>
                    <Col>{_t("new_price")}</Col>
                    <Col>{format.price(taxFlow?.newPrice?.newPrice)}</Col>
                  </Row>
                  <Row justify="space-between" gutter={16} className={!taxFlow?.tradePrice?.tradePrice ? "text-danger" : ""}>
                    <Col>{_t("trade_price")}</Col>
                    <Col>{format.price(taxFlow?.tradePrice?.tradePrice)}</Col>
                  </Row>
                  <Row justify="space-between" gutter={16} className={!isValidNum(taxFlow.registrationFee?.registrationFee) ? "text-danger" : ""}>
                    <Col>{_t("registration_fee")}</Col>
                    <Col>{format.price(taxFlow.registrationFee?.registrationFee)}</Col>
                  </Row>
                </>
              )}
            </>
          )}
        </div>}
    >
      {children}
    </Popover>
  )
}

function validateTaxableValue(taxCase: TaxCase, taxFlow: TaxFlow) {
  const taxableValueBreakdown = taxFlow.newPrice?.taxableValueBreakdown;

  let taxableValueIsOK = true;

  if (taxCase.vehicle?.isNew && !(taxableValueBreakdown?.purchase?.taxableValue && taxableValueBreakdown?.sale?.taxableValue)) {
    taxableValueIsOK = false;
  }
  return taxableValueIsOK
}

const reservationOptions = [
  {
    label: "Ingen stelnummer på køretøjet",
    value: "Da køretøjet ikke er angivet med stelnummer, kan vi ikke fastsætte bilens ekstraudstyr. Derfor er både køretøjets nypris og handelspris med forbehold for ændringer ved endelig værdifastsættelse. Send gerne stelnummer for opdateret beregning."
  },
  {
    label: "Eventuelt fejlagtigt CO2-emission",
    value: "Vi tager forbehold for registreringsafgiftsberegningen, da vi er usikre på CO2-tallet som er oplyst i forhåndsvurderingen.",
  },
  {
    label: "Eventuelt fejlagtigt batterikapacitet",
    value: "Vi tager forbehold for registreringsafgiftsberegningen, da vi er usikre på batterikapaciteten som er oplyst i forhåndsvurderingen.",
  },
  {
    label: "Nye biler",
    value: "Vær opmærksom på at vi kun har haft indkøbspris til rådighed, og derfor kan registreringsafgiften ændre sig når vi får tilsendt slutseddel. Send gerne slutseddel eller forventet salgspris til os når det er muligt, så regner vi en præcis registreringsafgift til jer.",
  },
  {
    label: "Beregnet uden EAP og FSD",
    value: `Køretøjet er prissat og beregnet uden EAP (Enhanced Autopilot) og FSD (Full Self-Driving).

Da vi ikke har mulighed for at tilgå køretøjets systemer, beder vi om et billede af bilens skærm, hvor det fremgår, hvilke funktioner der er installeret.

Hvis køretøjet har EAP og/eller FSD installeret, bedes I blot svare på denne mail, hvorefter vi fremsender en opdateret pris.`,
  },
  {
    label: "Fylder snart 1 år",
    value: `Da reglerne for udstyrsregulering ændrer sig ved køretøjets 1-års dag, og køretøjet fylder 1 år inden for de næste 30 dage, tages der forbehold for, at vurderingen kan ændre sig i forbindelse med, at køretøjet overgår til sit andet år.

Den endelige vurdering fastlægges først, når den præcise indregistreringsdato er kendt, da denne har væsentlig betydning for køretøjets værdi.`,
  },
];

const WithPopover: FC<Pick<CaseWarning, "remark">> = ({ remark, children }) => {
  return remark
    ? (
      <Popover title={remark?.title} content={remark?.content}>
        {children}
      </Popover>
    ) : (
      <>{children}</>
    )
}

const Warning = ({ message, remark }: CaseWarning) => {
  return (
    <WithPopover remark={remark}>
      <div className="d-flex align-items-center text-smallest mb-03">
        <Icon size="medium" className="mr-03 text-warning" name="alert" />
        {message}
      </div>
    </WithPopover>
  )
}

type CaseWarning = {
  message: string,
  remark?: {
    title: string | null,
    content: string | null
  }
}

function getCaseWarnings(taxCase: TaxCase): CaseWarning[] {
  const warnings: CaseWarning[] = [];
  const tradePrice = taxCase.calculation?.tradePrice?.tradePrice || 0;

  const depreciation = getDeprecitation({
    firstRegDate: taxCase.vehicle?.firstRegDate || new Date().toISOString(),
    newPrice: taxCase.calculation?.newPrice?.newPrice || 0,
    tradePrice: tradePrice,
    mileage: taxCase.vehicle?.mileage || 0,
  })

  if (depreciation.deviation.isLargeDeviation) {
    const depreciatedNewPrice = depreciation.deprecitationWithMileageRegulation;
    const standardFactor = depreciation.standard.factor;

    warnings.push({
      message: _t("standard_depreciation") + " " + _t("deviates").toLowerCase() + " " + _t("from", "the_vehicle"),
      remark: {
        title: `${_t("standard_depreciation")} (${format.percent(standardFactor)}) vs.
          ${_t("case_depreciation")} (${format.percent(depreciation.caseDeprecitationFactor)})`,
        content: `${format.price(depreciatedNewPrice)} (${_t("standard_depreciation")})
          ${_t("is_not", "comparable")} ${_t("with").toLowerCase()}
          ${format.price(tradePrice)} (${_t("trade_price")})`
      }
    })
  }
  return warnings;
}
